$(document).ready(function(){
	$('.homepage-gallery-7d4a3ebc-52db-4afc-bb87-43087cac1620 #promo-images').slick({
	  infinite: false,
	  slidesToShow: 1.7,
	  slidesToScroll: 1,
	});

	$('.carousel-modal').slick({
	  infinite: false,
	  slidesToShow: 1,
	  slidesToScroll: 1,
	  arrows: true,
	  dots: false,
	  adaptiveHeight: true
	});
	
	$('.side_recent_posts').slick({
	  infinite: false,
	  slidesToShow: 1,
	  slidesToScroll: 1,
	  arrows: true,
	  dots: false,
	  responsive: [
            {
                breakpoint: 767,
                settings: {
                    arrows: false,
                    dots: true,
                }
            },
        ]
	});
	

  $('.modalButton').bind("click", function () {
        if ($(this).attr('href')) {
            var strDataPopupName = $(this).attr('href');
            $(".overlay," + strDataPopupName).fadeIn();
        }
        $('.carousel-modal').slick('refresh');
    });

    $('.overlay, .closeBtn').bind("click", function () {
        $(".modal").fadeOut();
    });
	
	// $('.chat-cta').on('click',function(){
	// 	$('.fs-pop-signup').toggleClass('expand');
	// })

	$('.ship-cta').on('click',function(){
		$('.shipping-info').toggleClass('expand');
	})

	$('.shipping-info .close-btn').on('click',function(){
		$('.shipping-info').removeClass('expand');
	})

	// size guide
	$('.size-cta').on('click',function(){
		$('.size-info').toggleClass('expand');
	})

	$('.size-info .close-btn').on('click',function(){
		$('.size-info').removeClass('expand');
	})

	$("ul#main-nav li.has_sub_menu").mouseenter(function() {
		$('.scrollheader').addClass('expand');
	}).mouseleave(function() {
		$('.scrollheader').removeClass('expand');
	});

	$("#search_trigger").click(function() {
		$('.scrollheader').toggleClass('expand');
	});

    var current = location.pathname;
    $('ul#main-nav li ul.submenu li a, ul.article-tags a, header ul#main-nav li ul.megamenu li a').each(function() {
        var $this = $(this); 

        if ($this.attr('href') === current) {
            $this.addClass('active');
        }
    });


  	$('.more').click(function(e) {
    	e.preventDefault();
    	//
	    $(this).text(function(i, t) {
	      return t == 'Show less details' ? 'Show more details' : 'Show less details';
	    }).prev('.more-cont').slideToggle()

	    $(this).toggleClass('active');
  	});


})

$(window).on('hashchange', function () {
	modal();
	 $('.carousel-modal').slick('refresh');
});

$(window).on('load', function(){
	modal();
	 $('.carousel-modal').slick('refresh');
})

$(window).on('scroll', function(e){
	if($('#full-width-filter').length) {
		var _height = 0;
		
		if($('header').length){
			_height+= $('header').height() - 20;
		}

		if($('#collection-description').length){
			_height+= $('#collection-description').height() - 120;
		}

		_height+=0;

		if( $(window).scrollTop() > _height ) {
			$('body').addClass('scroll');
		} else {
			$('body').removeClass('scroll');
		}
	}
})


function modal(){
	var hash     = window.location.hash;
    var $section = $(hash);

    $section.fadeIn();
}